module.exports = __webpack_public_path__ + "static/media/f37ginger-regular-webfont.1fe76f74.woff2";